<template>
    <!-- Start Social Media Section -->
    <section class="social-media">
        <!-- Start Container -->
        <div class="container">
            <!-- Start Row -->
            <div class="row align-items-center">
                <!-- Start Column -->
                <div class="col-md-5">
                    <h4>Social Media</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                </div>
                <!-- End Column -->
                <!-- Start Column -->
                <div class="col-md-7">
                    <!-- Start Social Media Icons -->
                    <div class="social-media-icons text-end">
                        <i
                            v-for="social_media_icons_class in social_media_icons_classes"
                            :key="social_media_icons_class.id"
                            :class="[social_media_icons_class.className, 'fa-3x']"
                        >
                        </i>
                    </div>
                    <!-- End Social Media Icons -->
                </div>
                <!-- End Column -->
            </div>
            <!-- End Row -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Social Media Section -->
</template>

<style scoped lang="scss">

.social-media{
    padding: var(--main-padding);
    background-color: #EEE;
    .row{
        @media(max-width: 767px){
            h4 + p{
                line-height: 2.5;
                margin-bottom: 30px
            }
        }
        @media(max-width: 991px){
            h4 + p{
                line-height: 2.5;
                margin-bottom: 0
            }
        }
        .social-media-icons{
            i{
                margin-left: 30px;
                cursor: pointer;
                $social_media_info: (
                    fa-facebook-f: #3b5998,
                    fa-twitter: #00acee,
                    fa-google-plus-g: #db4a39,
                    fa-pinterest: #c8232c,
                    fa-instagram: #3f729b,
                    fa-stumbleupon: #f74425,
                    fa-rss: #ee802f
                );
                @each $social_name, $social_color in $social_media_info {
                    &.#{$social_name}{
                        transition: .3s;
                        &:hover{
                            color: $social_color
                        }
                    }
                }
                @media(max-width: 767px){
                    display: block;
                    margin: {
                        left: 0;
                        bottom: 30px
                    }
                }
                @media(max-width: 991px){
                    margin-bottom: 35px
                }
            }
            @media(max-width: 767px){
                margin-top: 50px
            }
            @media(max-width: 991px){
                text-align: center !important
            }
        }
        @media(max-width: 767px){
            text-align: center
        }
    }
}

</style>

<script>

import {social_media_icons_classes} from "../../assets/jsonData/index.json"

export default {
    
    name: "SocialMedia",

    data: function(){

        return {

            social_media_icons_classes: social_media_icons_classes

        }

    }
}

</script>